import { SET_DATA_FOR_CHECK } from '../actionTypes/request';
import { HYDRATE } from 'next-redux-wrapper';

const initialState = {
    checkList: {
        total: 0,
        data: {
            monthly: {
                total: 0,
                list: []
            },
            once: {
                total: 0,
                list: []
            }
        },
    }
};

export default  (state = initialState, action) => {

    const { type, payload } = action;

    switch (type) {
        case HYDRATE:
            return { ...state, ...action.payload.request };
        case SET_DATA_FOR_CHECK:
            return ({
                ...payload
            });
        default:
            return state;
    }
};
